// NOTE: stupid javascript
import { Actions } from '../classes/Actions';
export { Actions } from '../classes/Actions';

export default new Actions();
